import styled from 'styled-components'
import { Breakpoints } from '@volkswagen-onehub/components-core'

export const StyledSection = styled.div`
  padding: 45px 0;

  button:focus {
    outline: none;
  }

  legend {
    > div:last-child {
      font-size: ${props => props.theme.textAppearances.headline300.fontSize};
      font-family: ${props =>
        props.theme.textAppearances.headline300.fontFamily};
      line-height: ${props =>
        props.theme.textAppearances.headline300.lineHeight};
      font-weight: 200;
    }
  }

  fieldset {
    margin-top: 24px;

    span[class^='StyledErrorText'] {
      margin-bottom: 12px;
    }
  }

  div[class*='StyledChildWrapper'] {
    // selects div that has the string "StyledChildWrapper" in the class
    overflow: visible;
  }

  @media (max-width: ${Breakpoints.tablet}px) {
    padding: 20px 0 30px;
  }
`
export const StyledRow = styled.div`
  margin-top: ${props => props.marginTop}px;
  margin-bottom: ${props => props.marginBottom}px;
  
`
export const SumbitError = styled.div`
  &.submit-error {
    margin: -30px 0 30px;

    p {
      color: #e4002c;
      font-size: ${props => props.theme.textAppearances.copy100.fontSize};
      font-family: ${props => props.theme.textAppearances.copy100.fontFamily};
      line-height: ${props => props.theme.textAppearances.copy100.lineHeight};
    }
  }
`
